import React from 'react';

interface SelectionCounts {
  features: number;
  components: number;
  testCases: number;
}

interface GlobalActionBarProps {
  selection: SelectionCounts;
  onMove: () => void;
  onDelete: () => void;
  onBulkEdit: () => void;
  onClearSelection: () => void;
}

const GlobalActionBar: React.FC<GlobalActionBarProps> = ({
  selection,
  onMove,
  onDelete,
  onBulkEdit,
  onClearSelection
}) => {
  const totalSelected = selection.features + selection.components + selection.testCases;
  
  if (totalSelected === 0) return null;

  const buildSelectionText = () => {
    const parts: string[] = [];
    if (selection.features > 0) {
      parts.push(`${selection.features} Feature${selection.features !== 1 ? 's' : ''}`);
    }
    if (selection.components > 0) {
      parts.push(`${selection.components} Component${selection.components !== 1 ? 's' : ''}`);
    }
    if (selection.testCases > 0) {
      parts.push(`${selection.testCases} Test Case${selection.testCases !== 1 ? 's' : ''}`);
    }
    return parts.join(' • ');
  };

  const onlyComponents = selection.components > 0 && selection.features === 0 && selection.testCases === 0;
  const onlyTestCases = selection.testCases > 0 && selection.features === 0 && selection.components === 0;

  return (
    <div className="library-action-bar">
      <div className="library-action-bar-selection">
        <span className="selection-indicator">✓</span>
        <span className="selection-text">{buildSelectionText()}</span>
      </div>
      
      <div className="library-action-bar-actions">
        {/* Move - only for components or test cases (not mixed, not features only) */}
        {(onlyComponents || onlyTestCases) && (
          <button 
            className="btn btn-secondary btn-sm"
            onClick={onMove}
          >
            Move
          </button>
        )}

        {/* Bulk Edit - only for components or test cases (not mixed, not features only) */}
        {(onlyComponents || onlyTestCases) && (
          <button 
            className="btn btn-secondary btn-sm"
            onClick={onBulkEdit}
          >
            Bulk Edit
          </button>
        )}
        
        {/* Delete - always available */}
        <button 
          className="btn btn-secondary btn-sm"
          onClick={onDelete}
        >
          Delete
        </button>
        
        <button 
          className="btn btn-ghost btn-sm"
          onClick={onClearSelection}
          title="Clear selection"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default GlobalActionBar;
